// PKCE (RFC 7636) helpers for the Authorization Code + PKCE login flow.
// All values are generated client-side with the Web Crypto API.

function base64UrlEncode(bytes) {
  let str = "";
  const arr = new Uint8Array(bytes);
  for (let i = 0; i < arr.length; i++) str += String.fromCharCode(arr[i]);
  return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

// A high-entropy random string (43-128 chars) per the spec.
export function generateCodeVerifier() {
  const random = new Uint8Array(64);
  crypto.getRandomValues(random);
  return base64UrlEncode(random);
}

// challenge = BASE64URL(SHA256(verifier)) — the S256 method.
export async function generateCodeChallenge(codeVerifier) {
  const data = new TextEncoder().encode(codeVerifier);
  const digest = await crypto.subtle.digest("SHA-256", data);
  return base64UrlEncode(digest);
}

// Random opaque value for CSRF protection on the redirect.
export function generateState() {
  const random = new Uint8Array(16);
  crypto.getRandomValues(random);
  return base64UrlEncode(random);
}

// Begin the Authorization Code + PKCE flow via a top-level GET navigation to
// /oauth/authorize. This is what triggers SSO: if a shared auth-server session
// already exists (from logging into the other app), the backend redirects back
// SILENTLY with a code; otherwise it shows its login page. Used both as the
// initial SSO probe on app load and as the "Sign in" action.
export async function beginPkceAuthorize(apiUrl, clientId, { prompt } = {}) {
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = await generateCodeChallenge(codeVerifier);
  const state = generateState();

  sessionStorage.setItem('pkce_code_verifier', codeVerifier);
  sessionStorage.setItem('pkce_state', state);

  const redirectUri = window.location.origin + '/auth/callback';
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: clientId,
    redirect_uri: redirectUri,
    code_challenge: codeChallenge,
    code_challenge_method: 'S256',
    scope: 'openid profile',
    state,
  });
  // prompt=none performs a silent SSO probe (no login form shown on the server).
  if (prompt) params.set('prompt', prompt);

  window.location.href = apiUrl + '/oauth/authorize?' + params.toString();
}
